(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		filterToSelectedVariant();
	}

	// On load the gallery holds every photo; narrow it to the variant the
	// page opened on (see filterProductMedia in global.js).
	function filterToSelectedVariant() {
		if (typeof filterProductMedia !== "function") return;
		document.querySelectorAll("variant-radios, variant-selects").forEach(function (picker) {
			const section = picker.dataset.section;
			const json = picker.querySelector('script[type="application/json"]');
			const input = document.querySelector("#product-form-" + section + ' input[name="id"]');
			if (!section || !json || !input) return;
			let variants;
			try {
				variants = JSON.parse(json.textContent);
			} catch (e) {
				return;
			}
			const variant = variants.find(function (v) {
				return String(v.id) === input.value;
			});
			filterProductMedia(section, variant);
		});
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	//window.addEventListener("resize", function () {
	//	$(".product-section .js-media-list").each(function () {
	//		this.swiper.destroy();
	//	});
	//	$(".product-section .js-media-sublist").each(function () {
	//		this.swiper.destroy();
	//	});

	//	swiperInit();
	//});

	swiperInit();
})();
